import React from "react";
import { Menu, SplitButton } from "@sscs/ui";
import { UploadOption } from "Types";

type UploadButtonProps = {
  selectedOption: UploadOption;
  className?: string;
  onClick: (option: UploadOption) => void;
  onOptionChange: (option: UploadOption) => void;
};

const UploadButton = ({
  selectedOption,
  className,
  onClick,
  onOptionChange,
}: UploadButtonProps): React.JSX.Element => {
  const optionLabels: Record<UploadOption, string> = {
    file: "Upload file",
    url: "Import P/URL",
  };

  return (
    <SplitButton
      id="upload"
      aria-label="select upload type"
      label={optionLabels[selectedOption]}
      onButtonClick={() => onClick(selectedOption)}
      className={className}
    >
      <Menu.List>
        {Object.keys(optionLabels).map((option: UploadOption) => (
          <Menu.Item
            key={option}
            selected={option === selectedOption}
            onClick={() => onOptionChange(option)}
          >
            {optionLabels[option]}
          </Menu.Item>
        ))}
      </Menu.List>
    </SplitButton>
  );
};

export default UploadButton;
